/** ブランドヘッダーの高さ */
export const BRAND_HEADER_HEIGHT = '64px';
